import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface CheckoutStepViewedEventProperties {
  checkout_id: string
  step: number
}

export class CheckoutStepViewedEvent extends Event<CheckoutStepViewedEventProperties> {
  static displayName = 'Checkout Step Viewed'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
